var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 0V4.75H16.625L11.875 0Z",
    fill: "#111F3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 5.9375C11.2207 5.9375 10.6875 5.40431 10.6875 4.75V0H3.5625C2.90819 0 2.375 0.533188 2.375 1.1875V17.8125C2.375 18.468 2.90819 19 3.5625 19H15.4375C16.093 19 16.625 18.468 16.625 17.8125V5.9375H11.875ZM7.125 16.625H4.75V13.0625H7.125V16.625ZM10.6875 16.625H8.3125V10.6875H10.6875V16.625ZM14.25 16.625H11.875V8.3125H14.25V16.625Z",
    fill: "#111F3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.a789d7b99abe0a157b703535b6bfae91.svg";
export { ForwardRef as ReactComponent };